import { useEffect, useRef, useState } from 'react';

import useSidebarStore from '@/components/sidebar/hooks/useSidebarStore';
import useApiErrorStatus from '@/hooks/useApiErrorStatus';
import { useGetConflicten } from '@/queries/conflicten/useGetConflicten';
import { useConflicten } from '@/state/selectors/useConflicten';
import useClientState from '@/state/useClientState';

import PanelHeader from '../stickyPanelHeader/PanelHeader';

import { ConflictenFilterDialog } from './conflictenFilter/ConflictenFilterDialog';
import { defaultFilter } from './conflictenFilter/conflictenFilterModel';
import ConflictenLijst from './ConflictenLijst';

import styles from './Conflicten.module.css';

const useSyncConflictenUitBackendMetClientState = () => {
  const conflictenRefreshVersion = useSidebarStore((s) => s.conflictenRefreshVersion);
  const { data, isError, isSuccess, errorUpdateCount } = useGetConflicten(30_000);
  const { refetch } = useGetConflicten();
  const { handleApiStatus } = useApiErrorStatus();
  const vervangAlleConflicten = useClientState((state) => state.vervangAlleConflicten);

  const lastFetchRef = useRef<number>(0);
  const firstEventRef = useRef(true);

  useEffect(() => {
    if (data) {
      vervangAlleConflicten(data);
    }
  }, [data, vervangAlleConflicten]);

  useEffect(() => {
    handleApiStatus('alleConflicten', isError && !isSuccess);
  }, [isError, isSuccess, errorUpdateCount]);

  useEffect(() => {
    const now = Date.now();
    if (firstEventRef.current) {
      void refetch();
      lastFetchRef.current = now;
      firstEventRef.current = false;
    } else if (now - lastFetchRef.current > 500) {
      void refetch();
      lastFetchRef.current = now;
    }
  }, [conflictenRefreshVersion, refetch]);
};

function Conflicten({ panelMenuInformation }) {
  useSyncConflictenUitBackendMetClientState();

  const { conflictenView } = useConflicten(undefined, undefined, true);
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const currentFilter = useSidebarStore((state) => state.conflictenFilter);
  const setCurrentFilter = useSidebarStore((state) => state.setConflictenFilter);

  return (
    <div className={styles.conflictenStyle}>
      <PanelHeader
        title='Conflicten'
        sectionId='conflicten'
        onFilterMenuItemClick={() => setShowFilterDialog(true)}
        filterActive={currentFilter !== defaultFilter}
      />
      <ConflictenLijst
        conflicten={conflictenView ?? []}
        filter={currentFilter}
        panelMenuInformation={panelMenuInformation}
      />
      {showFilterDialog && (
        <ConflictenFilterDialog
          showDialog={showFilterDialog}
          handleOpenChange={setShowFilterDialog}
          huidigFilter={currentFilter}
          setNieuwFilter={setCurrentFilter}
        />
      )}
    </div>
  );
}
export default Conflicten;
